// Libs
import React from 'react';
import { Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// Components
import OrderIdLink from '../../../Buttons/OrderIdLink';
import IconButton from '../../../../Button/IconButton/IconButton';

const OrderCardButtons = ({
  order,
  isDistro,
  isMobileMode,
  gridPropValues,
  onAddToMyKits,
}) => (
  <>
    <Grid
      container
      alignContent={isMobileMode ? 'center' : 'initial'}
      item
      flexBasis={gridPropValues({
        lgSize: 12,
        mdSize: 8,
        unit: '%',
      })}
      maxWidth={gridPropValues({
        lgSize: 12,
        mdSize: 8,
        unit: '%',
      })}
      order={1}>
      <OrderIdLink order={order} />
    </Grid>
    <Grid
      container
      item
      maxWidth={gridPropValues({
        lgSize: 12,
        mdSize: 6,
        unit: '%',
      })}
      flexBasis={gridPropValues({
        lgSize: 12,
        mdSize: 6,
        unit: '%',
      })}
      order={gridPropValues({ lgSize: 2, mdSize: 6 })}
      alignContent={isMobileMode ? 'center' : 'initial'}>
      {!isDistro && (
        <IconButton
          data-testid={'add-to-kits-button'}
          disabled={!order.can_be_added_to_kit}
          onClick={onAddToMyKits}
          startIcon={<AddIcon />}>
          Add To My Kits
        </IconButton>
      )}
    </Grid>
  </>
);

export default OrderCardButtons;
